export enum SignatureStatus {
  VALID = 'valid',
  INVALID = 'invalid',
  NOT_SIGNED = 'not_signed',
}
